import TableComponent from './table'

export const TableWithPagination =(props)=>{
  return(
    <TableComponent {...props}/>
  )
}
